import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react'; // Import the arrow icons

const Filters = ({ games, label, drawTime, onSelectedGame }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedGame, setSelectedGame] = useState('');

  const handleSelectedGame = (game) => {
    setSelectedGame(game);
    onSelectedGame(game);
  };
  return (
    <>
      <label htmlFor='game' className='text-xs font-medium '>
        {label}
      </label>
      <div className='relative w-full'>
        <button
          id='dropdownButton'
          className='w-full p-2.5 text-xs font-normal text-gray-700 bg-white border rounded-md shadow-sm flex justify-between items-center '
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <span>
            {games.find((game) => game.id === selectedGame)?.name || 'All'}
          </span>
          <span className='text-gray-500'>
            {dropdownOpen ? (
              <ChevronUp className='h-4 w-4' /> // ChevronUp icon for open state
            ) : (
              <ChevronDown className='h-4 w-4' /> // ChevronDown icon for closed state
            )}
          </span>
        </button>
        {dropdownOpen && (
          <ul className='absolute left-0 z-10 w-full mt-1 bg-white border rounded-md shadow-md'>
            <li
              onClick={() => {
                handleSelectedGame('');
                setDropdownOpen(false);
              }}
              className={`p-2.5 text-xs text-black hover:bg-[#E1E7EF] cursor-pointer`}
            >
              All
            </li>
            {games.map((game, index) => (
              <li
                key={game.id}
                onClick={() => {
                  handleSelectedGame(game.id);
                  setDropdownOpen(false);
                }}
                className={`p-2.5 text-xs text-black hover:bg-[#E1E7EF] cursor-pointer border-t border-[#E1E7EF]`}
              >
                {game.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default Filters;
